/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import { debounce } from "lodash";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";
import { makeStyles } from "@material-ui/styles";
import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AutoForm from "../form/functional/AutoForm";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import failureKey from "../../lib/common/failureKey";


const useStyles = makeStyles((theme) => ({
	keepOpenSwitch: {
		marginLeft: "8px"
	},

	label: {
		fontSize: "smaller",
		color: theme.palette.primary.text
	},
}));

function CustomerMaterialDialog(props) {
	const {
		id,
		schema,
		moveable,
		resizable,
		fullWidth,
		maxWidth,

		initialData,

		onClose,
		onInitialized,
		onSuccess,

		...others
	} = props;
	const classes = useStyles();
	const { t } = useTranslation();

	const [dialogInstance, setDialogInstance] = useState();
	const [formData, setFormData] = useState({});

	const [okButtonDisabled, setOkButtonDisabled] = useState(true);
	const [responseOkButtonDisabled, setresponseOkButtonDisabled] =
		useState(false);

	const [customerMaterialGrid, setCustomerMaterialGrid] = useState();
	const [customerMaterialSelect, setCustomerMaterialSelect] = useState();
	const [keepOpen, setKeepOpen] = useState(false);
	const [notification, setNotification] = useState({
		open: false,
		severity: "success",
		msg: "",
	});

	const checkItemValidataion = (schema, formData) => {
		for (const column of schema.columns) {
			let [valid, msg] = checkValidation(
				"create",
				column,
				column.validation,
				formData[column.name] || ""
			);

			if (!valid) {
				notifyWarning(msg);
				return false;
			}
		}

		return true;
	};
	const notifyWarning = (msg) => {
		setNotification({
			severity: "warning",
			msg: msg,
			open: true,
		});
	};

	const notifyFailure = (msg) => {
		setNotification({
			severity: "error",
			msg: msg,
			open: true,
		});
	};

	useEffect(() => {
		if (customerMaterialGrid) {
			(async () => {
				customerMaterialGrid.selectionChanged.addHandler(
					debounce((grid, event) => {
						if (grid.selectedItems && grid.selectedItems[0]) {
							setCustomerMaterialSelect(grid.selectedItems[0]);
						} else {
							setCustomerMaterialSelect();
						}
					}, 10)
				);

				customerMaterialGrid.itemsSourceChanged.addHandler(
					debounce((grid, event) => {
						if (grid.selectedItems && grid.selectedItems[0]) {
							setCustomerMaterialSelect(grid.selectedItems[0]);
						} else {
							setCustomerMaterialSelect();
						}
					}, 10)
				);
			})();
		}
	}, [customerMaterialGrid]);

	useEffect(() => {
		if (customerMaterialSelect) {
			(async () => {
				setFormData((formData) => {
					let newFormData = {
						...formData,
						companyCode: customerMaterialSelect.companyCode,
						materialCode: customerMaterialSelect.materialCode,
						materialCodeVer: customerMaterialSelect.materialCodeVer,
						companyName: customerMaterialSelect.companyName,
						materialName: customerMaterialSelect.materialName,
						custUnitId: customerMaterialSelect?.unitId || null,
					};

					return newFormData;
				});
			})();
		}
	}, [customerMaterialSelect]);

	const onDialogInitialized = (instance) => {
		setDialogInstance(instance);

		if (onInitialized) {
			onInitialized(instance);
		}
	};

	const onApiSuccess = (result) => {
		setresponseOkButtonDisabled(false);

		if (onSuccess) {
			setTimeout(() => onSuccess(result.data), 0);
		}

		dialogInstance.hide();
	};

	const onApiFailure = (reason) => {
		setresponseOkButtonDisabled(false);

		notifyFailure(
			t(failureKey("insert", reason.response?.status), {
				reason: reason.response ? reason.response.data : JSON.stringify(reason),
			})
		);
	};

	const onOk = (schema, formData) => {
		setresponseOkButtonDisabled(true);

		if (!checkItemValidataion(schema, formData)) {
			console.error("Form Validation Failed");
			setresponseOkButtonDisabled(false);
			return;
		}

		if (schema.validation) {
			let [valid, msg] = checkConditionWithMsg(
				formData,
				schema.validation
			);

			if (!valid) {
				notifyWarning(
					t("warning.formDataValidationFail", { msg: msg })
				);
				setresponseOkButtonDisabled(false);
				return;
			}
		}

		// build base api url

		const url = `/api/${schema.name}`;

		let apiData = { ...formData };
		let form = new FormData();

		let json = {};
		let deleted = {};

		if (schema && !schema.columnMap) {
			let columnMap = {};
			schema.columns.map((column) => (columnMap[column.name] = column));
			schema.columnMap = columnMap;
		}

		for (const formItem in apiData) {
			if (
				schema.columnMap &&
				schema.columnMap[formItem] &&
				schema.columnMap[formItem].formItemType === "file"
			) {
				deleted[formItem] = apiData[formItem].deletedFiles;

				for (const file of apiData[formItem].activeFiles) {
					if (file.type === "url") continue;

					form.append(formItem, file.file);
				}
			} else {
				if (apiData[formItem] !== undefined) {
					json[formItem] = apiData[formItem];
				}
			}
		}

		form.append("deleted", JSON.stringify(deleted));
		form.append("json", JSON.stringify(json));

		apiClient
			.post(url, form, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((result) => onApiSuccess(result))
			.catch((reason) => onApiFailure(reason));
	};

	const onCancel = () => {
		dialogInstance.hide();

		setCustomerMaterialSelect();

		setFormData();
	};

	const onChangeFormData = (formData) => {
		setFormData(formData);
	};

	const onCloseNotification = () => {
		setNotification((notification) => {
			return { ...notification, open: false };
		});
	};

	const onCloseDialog = () => {
		if (onClose) {
			onClose();
		}

		setCustomerMaterialSelect();

		setFormData();
	};

	const checkKeepOpen = () => {
			return (
				<>
					<FormControlLabel
						control={
							<Checkbox
								className={classes.keepOpenSwitch}
								checked={keepOpen}
								color="primary"
								onChange={() => setKeepOpen((keepOpen) => (!keepOpen))}
								name="checkKeepOpen"
								size="small"
							/>
						}
						label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
					/>
					<div style={{ flexGrow: 1 }}></div>
				</>
			)
		}
	

	const onLoadData = (data) => {
		setOkButtonDisabled(data.length < 1 ? true : false);
	};

	return (
		<Dialog
			id={id}
			moveable={moveable ? moveable : uiConf.dialogMoveable}
			resizable={resizable ? resizable : uiConf.dialogResizable}
			fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
			maxWidth="lg"
			onClose={onCloseDialog}
			onInitialized={onDialogInitialized}
			{...others}
		>
			<DialogHeaderWithClose>
				<DialogTitle>{t("dialog.title.CustomerMaterial.create")}</DialogTitle>
			</DialogHeaderWithClose>

			<Divider />

			<DialogContent style={{ padding: "0px", height: "600px" }}>
				<ReflexContainer orientation="vertical">
					<ReflexElement flex={0.65} data-cy="CustomerMaterialGrid">
						<BasicCrudScreenType
							id="MomSysVwMaterialByCompany"
							embededInOtherScreenType
							headerTitle={t("tableName.MomSysMaterialByCompany")}
							view="MomSysVwMaterialByCompany"
							onLoadData={onLoadData}
							noCreate
							noEdit
							noDelete
							noExcel
							onInitialized={(grid) => {
								grid.selectionMode = "Row";
								setCustomerMaterialGrid(grid);
							}}
						/>
					</ReflexElement>

					<ReflexSplitter
						style={{ width: "1px", color: "lightgray" }}
					/>

					<ReflexElement flex={0.35}>
						<div
							style={{
								padding: "16px",
							}}
						>
							<AutoForm
								id="customer-material-form"
								schema={schema}
								mode={"edit"}
								initialData={formData}
								onChange={onChangeFormData}
							/>
						</div>
					</ReflexElement>
				</ReflexContainer>

				<Snackbar
					open={
						notification.open && notification.severity !== "success"
					}
					autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
					onClose={onCloseNotification}
				>
					<Alert
						onClose={onCloseNotification}
						variant="filled"
						severity={notification.severity}
					>
						{notification.msg}
					</Alert>
				</Snackbar>
			</DialogContent>

			<Divider />

			<DialogActionsOkCancel
			    firstActionComponent={checkKeepOpen}
				labels={[t("common.add")]}
				buttonDisabled={[
					okButtonDisabled || responseOkButtonDisabled,
					false,
				]} /* [okButtonDisabled, cancelButtonDisabled] */
				onOk={() => onOk(schema, formData)}
				onCancel={onCancel}
			/>
		</Dialog>
	);
}

export default CustomerMaterialDialog;
